import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styled from "styled-components";
import { Helmet } from "react-helmet";

import { getSearchPage } from "../configureStore";
import { fetchSearchPage } from "../configureStore/searchPage";
import { getHelmet } from "../utilities";
import { FromTopPage, Banner, GridWrapper } from "../theme";
import SearchForm from "../components/search/SearchForm";
import NotFound from "../components/NotFound";
import Error from "../components/Error";
import PageLoader from "../components/loader/PageLoader";
import SearchList from "../components/search/SearchList";
import Pagination from "../components/Pagination";
import JoinUs from "../components/JoinUs";

const Container = styled(FromTopPage)`
  header {
    margin-bottom: 60px;

    @media (max-width: 767px) {
      margin-bottom: 30px;
    }
  }
`;

const NoResults = styled.div`
  text-align: center;

  h2 {
    color: black;
    font-size: 5.8rem;
    margin-bottom: 40px;
    text-transform: uppercase;

    @media (max-width: 767px) {
      font-size: 3.5rem;
      margin-bottom: 20px;
    }

    span {
      font-weight: 100;
    }
  }

  p {
    font-size: 1.8rem;
    line-height: 3rem;

    @media (max-width: 767px) {
      font-size: 1.6rem;
      padding: 0 5px;
    }
  }

  form {
    height: 44px;
    margin: 30px auto 95px;
    max-width: calc(100% - 40px);
    width: 480px;

    @media (max-width: 767px) {
      margin-bottom: 30px;
    }
  }
`;

export class Search extends Component {
  static fetchInitialData({ query, page }) {
    return [fetchSearchPage(query, page)];
  }

  componentDidMount() {
    this.fetchContent();
  }

  componentDidUpdate() {
    this.fetchContent();
  }

  fetchContent() {
    const { searchPage, dispatch, match } = this.props;
    if (
      !searchPage.isEmpty &&
      !searchPage.isFetching &&
      !searchPage.error &&
      !searchPage.content.length
    ) {
      dispatch(fetchSearchPage(match.params.query, match.params.page));
    }
  }

  render() {
    const searchPage = this.props.searchPage;

    if (searchPage.isEmpty) {
      return (
        <Container>
          <Helmet>
            {getHelmet(
              `Résultats de recherche pour "${this.props.match.params.query}"`,
              `Retrouvez tous les contenus correspondants  à la recherche "${this.props.match.params.query}" sur Le Média.`,
              this.props.location.pathname
            )}
          </Helmet>
          <Banner>
            <GridWrapper>
              <div>
                <h1>{this.props.match.params.query}</h1>
              </div>
            </GridWrapper>
          </Banner>
          <NoResults>
            <h2>
              Aucun <span>résultat</span>
            </h2>
            <p>
              Il n'y a pas de résultats&nbsp;pour&nbsp;votre&nbsp;recherche.
              <br />
              Souhaitez-vous effectuer une nouvelle recherche ?
            </p>
            <SearchForm />
          </NoResults>
        </Container>
      );
    }

    if (!searchPage.nbrPages && searchPage.error) {
      if (searchPage.error === "404") {
        return <NotFound />;
      }

      return <Error message={searchPage.error} />;
    }

    if (!searchPage.nbrPages) {
      return <PageLoader />;
    }

    return (
      <Container>
        <Helmet>
          {getHelmet(
            `Résultats de recherche pour "${this.props.match.params.query}"`,
            `Retrouvez tous les contenus correspondants  à la recherche "${this.props.match.params.query}" sur Le Média.`,
            this.props.location.pathname
          )}
        </Helmet>
        <Banner>
          <GridWrapper>
            <div>
              <h1>{this.props.match.params.query}</h1>
              {searchPage.total && (
                <p>
                  Voici les <strong>{searchPage.total}</strong> résultats de
                  votre recherche
                </p>
              )}
            </div>
          </GridWrapper>
        </Banner>
        <Pagination nbrPages={searchPage.nbrPages} />
        <SearchList searchList={searchPage} />
        <Pagination nbrPages={searchPage.nbrPages} />
        <JoinUs />
      </Container>
    );
  }
}

Search.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      query: PropTypes.string.isRequired,
      page: PropTypes.string,
    }).isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  searchPage: PropTypes.shape({
    isEmpty: PropTypes.bool,
    isFetching: PropTypes.bool,
    error: PropTypes.string,
    nbrPages: PropTypes.number,
    total: PropTypes.number,
    content: PropTypes.array,
  }).isRequired,
};

export default connect((state, { match }) => ({
  searchPage: getSearchPage(state, match.params.query, match.params.page),
}))(Search);
